export const SEARCH_INPUT_CHANGED = 'SEARCH_INPUT_CHANGED';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const POINTER_INSIDE_NAV_BOX = 'POINTER_INSIDE_NAV_BOX';
export const SHOW_SEARCH_RESULTS = 'SHOW_SEARCH_RESULTS';
export const NAV_INDEX_CHANGED = 'NAV_INDEX_CHANGED';
export const ITEM_SELECTED = 'ITEM_SELECTED';



/** WEBPACK FOOTER **
 ** app/components/search-box/state/search-box-consts.js
 **/